module.exports = __webpack_public_path__ + "static/elbil-verksted-639a0df48372fad9cb61588ee427772c.mp4";